<div
    class="available-dates-selector-component"
    [class.device-mobile]="isMobile()"
    [class.device-desktop]="!isMobile()"
    fxLayout="column"
>
    <div
        class="report-adjustments-period-component_section"
        fxLayout="column"
        fxFlexAlign="center center"
    >
        <!-- <div fxLayout="column" class="gap-8">
            <span class="text-14-regular color-text-primary"
                >Base de dados</span
            >
            <dsn-select
                [value]="formPeriod.scenario.props._id"
                [placeholder]="'Selecione o cenário'"
                [size]="isMobile() ? 'medium' : 'small'"
                [disabled]="true"
                fxFlex
            >
                @for (scenario of scenarios; track scenario.props._id) {
                    <dsn-option
                        (onClick)="onSelectScenario(scenario)"
                        [value]="scenario.props._id"
                        >{{ scenario.props.name }}</dsn-option
                    >
                }
            </dsn-select>
        </div> -->

        <div class="report-adjustments-period-component_tabs" fxLayout="row">
            <dsn-tabs [size]="'small'" [flex]="true">
                @for (
                    navigation of navigationPeriods;
                    track trackByNavigation($index, navigation)
                ) {
                    <dsn-tab
                        [fullWidth]="true"
                        [active]="navigation.value === formPeriod.periodName"
                        (click)="onNavigate(navigation)"
                        >{{ navigation.label }}</dsn-tab
                    >
                }
            </dsn-tabs>
        </div>
        <div
            class="report-adjustments-period-component_section_content {{
                !isMobile() && 'gap-16'
            }}"
            fxLayout="column"
        >
            <!-- Start Period Section -->
            @if (typeSelect === "period") {
                <div
                    class="report-adjustments-perios-component_section_input"
                    fxLayout="column"
                >
                    <span class="text-14-regular"> Início </span>

                    <div class="gap-16">
                        <dsn-select
                            [value]="formPeriod.start.year"
                            [placeholder]="'Selecione o ano'"
                            [size]="isMobile() ? 'medium' : 'small'"
                            [disabled]="disabledStartDate"
                        >
                            @for (
                                year of periods[formPeriod.periodName!].years;
                                track trackByYear($index, year)
                            ) {
                                <dsn-option
                                    (onClick)="
                                        onSelectPeriodYear(year, 'start')
                                    "
                                    [value]="year.value"
                                    [disabled]="year.disabled"
                                    >{{ year.label }}</dsn-option
                                >
                            }
                        </dsn-select>

                        @if (periods[formPeriod.periodName!].months) {
                            <dsn-select
                                [value]="formPeriod.start.month"
                                [placeholder]="'Selecione o mês'"
                                [size]="isMobile() ? 'medium' : 'small'"
                                [disabled]="disabledStartDate"
                            >
                                @for (
                                    period of periods[formPeriod.periodName!]
                                        .months;
                                    track trackByMonth($index, period)
                                ) {
                                    <dsn-option
                                        (onClick)="
                                            onSelectPeriodMonth(period, 'start')
                                        "
                                        [value]="period.value"
                                        [disabled]="period.disabled"
                                        >{{ period.label }}</dsn-option
                                    >
                                }
                            </dsn-select>
                        }
                    </div>
                </div>
            }

            <!-- End Period Section -->
            <div
                class="report-adjustments-perios-component_section_input"
                fxLayout="column"
            >
                @if (typeSelect === "period") {
                    <span class="text-14-regular"> Final </span>
                }

                <div class="gap-16" fxLayout="row">
                    <dsn-select
                        [value]="formPeriod.end.year"
                        [placeholder]="'Selecione o ano'"
                        [size]="isMobile() ? 'medium' : 'small'"
                    >
                        @for (
                            year of periodsEnd[formPeriod.periodName!].years;
                            track trackByYear($index, year)
                        ) {
                            <dsn-option
                                (onClick)="onSelectPeriodYear(year, 'end')"
                                role="option"
                                [value]="year.value"
                                [disabled]="year.disabled"
                                >{{ year.label }}</dsn-option
                            >
                        }
                    </dsn-select>

                    @if (periodsEnd[formPeriod.periodName!].months) {
                        <dsn-select
                            [value]="
                                formPeriod.allMonthsCompare
                                    ? 'allMonths'
                                    : formPeriod.end.month
                            "
                            [placeholder]="'Selecione o mês'"
                            [size]="isMobile() ? 'medium' : 'small'"
                        >
                            @if (
                                typeSelect === "comparation" &&
                                formPeriod.periodName === "monthly"
                            ) {
                                <dsn-option
                                    (onClick)="onSelectAllMonthsCompare()"
                                    [value]="'allMonths'"
                                >
                                    Todos os meses
                                </dsn-option>
                            }
                            @for (
                                period of periodsEnd[formPeriod.periodName!]
                                    .months;
                                track trackByMonth($index, period)
                            ) {
                                <dsn-option
                                    (onClick)="
                                        onSelectPeriodMonth(period, 'end')
                                    "
                                    [value]="period.value"
                                    [disabled]="period.disabled"
                                    >{{ period.label }}</dsn-option
                                >
                            }
                        </dsn-select>
                    }
                </div>
                @if (isMobile()) {
                    <ng-content select="[mobile-content]"></ng-content>
                }
            </div>
        </div>
    </div>
    @if (!isMobile()) {
        <div
            class="transclude-area"
            [class.fixed-actions]="configs?.fixedActions"
        >
            <ng-content select="[desktop-content]"></ng-content>
        </div>
    }
    <!-- Footer Section -->
    <div
        class="report-adjustments-period-component_footer {{
            !isMobile() && 'gap-16'
        }}"
        [fxLayout]="isMobile() ? 'column' : 'row'"
        [fxLayoutAlign]="isMobile() ? 'center center' : 'end none'"
        [class.fixed-actions]="configs?.fixedActions"
        style="margin-top: var(--spacing-16)"
    >
        @if (isMobile()) {
            <dsn-button
                class="full-width"
                [label]="typeSelect === 'comparation' ? 'Comparar' : 'Aplicar'"
                (onClick)="onApplyPeriod()"
                [type]="'primary'"
                [size]="'large'"
                [width]="'full'"
                [disabled]="isDisabled()"
            ></dsn-button>
            @if (typeSelect === "comparation") {
                <dsn-button
                    class="full-width"
                    (onClick)="onResetPeriod()"
                    [label]="'Limpar'"
                    [iconLeft]="'fa-solid fa-trash-can'"
                    [type]="'secondary'"
                    [size]="'large'"
                    [width]="'full'"
                    [disabled]="isDisabled()"
                ></dsn-button>
            }
        } @else {
            @if (typeSelect === "comparation") {
                <dsn-button
                    class="full-width"
                    (onClick)="onResetPeriod()"
                    [label]="'Limpar'"
                    [iconLeft]="'fa-solid fa-trash-can'"
                    [type]="'secondary'"
                    [size]="'medium'"
                    [width]="'full'"
                    [disabled]="isDisabled()"
                ></dsn-button>
            }

            <dsn-button
                class="full-width"
                [label]="typeSelect === 'comparation' ? 'Comparar' : 'Aplicar'"
                (onClick)="onApplyPeriod()"
                [type]="'primary'"
                [size]="'medium'"
                [width]="'full'"
                [disabled]="isDisabled()"
                [active]="false"
            ></dsn-button>
        }
    </div>
</div>
